export default "__VITE_ASSET__DGVe7bm5__"